module.exports = __webpack_public_path__ + "static/2-090827eb4cf25e00af30a9f3f3d218a6.jpeg";